var map = {
	"./translator-CH.svg": 776,
	"./translator-EN.svg": 777,
	"./translator-RU.svg": 778,
	"./translator__ch-en.svg": 779,
	"./translator__ch-ru.svg": 780,
	"./translator__en-ch.svg": 781,
	"./translator__en-ru.svg": 782,
	"./translator__ru-ch.svg": 783,
	"./translator__ru-en.svg": 784,
	"./translator_ch-en.svg": 785,
	"./translator_ch.svg": 786,
	"./translator_en.svg": 787,
	"./translator_ru.svg": 788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 641;